import { create } from 'zustand';
import { type Label } from '@/entities/label';

interface LabelStore {
  labels: Label[];
  setLabels: (labels: Label[]) => void;
  addLabel: (label: Label) => void;
  updateLabel: (id: string, label: Partial<Label>) => void;
  deleteLabel: (id: string) => void;
  getLabelsByTenant: (tenantId: string) => Label[];
}

export const useLabelStore = create<LabelStore>((set, get) => ({
  labels: [],
  setLabels: (labels) => set({ labels }),
  addLabel: (label) => set((state) => ({ labels: [...state.labels, label] })),
  updateLabel: (id, updatedLabel) =>
    set((state) => ({
      labels: state.labels.map((l) => (l.id === id ? { ...l, ...updatedLabel } : l)),
    })),
  deleteLabel: (id) => set((state) => ({ labels: state.labels.filter((l) => l.id !== id) })),
  getLabelsByTenant: (tenantId) => get().labels.filter((l) => l.tenant_id === tenantId),
}));
